<template>
  <div class="partner-area pb-75">
    <div class="container mw-1356">
      <div class="row justify-content-center">
        <div
          class="col-xxl-2 col-sm-6 col-md-4"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="100"
        >
          <RouterLink to="/about-us">
            <img src="@/assets/images/partner-1.png" alt="شريكنا" />
          </RouterLink>
        </div>
        
        <div
          class="col-xxl-2 col-sm-6 col-md-4"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <RouterLink to="/about-us">
            <img src="@/assets/images/partner-2.png" alt="شريكنا" />
          </RouterLink>
        </div>
        
        <div
          class="col-xxl-2 col-sm-6 col-md-4"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="300"
        >
          <RouterLink to="/about-us">
            <img src="@/assets/images/partner-3.png" alt="شريكنا" />
          </RouterLink>
        </div>
        
        <div
          class="col-xxl-2 col-sm-6 col-md-4"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="400"
        >
          <RouterLink to="/about-us">
            <img src="@/assets/images/partner-4.png" alt="شريكنا" />
          </RouterLink>
        </div>
        
        <div
          class="col-xxl-2 col-sm-6 col-md-4"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="500"
        >
          <RouterLink to="/about-us">
            <img src="@/assets/images/partner-5.png" alt="شريكنا" />
          </RouterLink>
        </div>
        
        <div
          class="col-xxl-2 col-sm-6 col-md-4"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="600"
        >
          <RouterLink to="/about-us">
            <img src="@/assets/images/partner-6.png" alt="شريكنا" />
          </RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  // تم تغيير الاسم إلى اسم متعدد الكلمات لتجنب خطأ ESLint
  name: "PartnerLogos",
});
</script>